export default __webpack_public_path__ + "static/logo17-40485adb870e8818cdeffc4a1c130183.png";